//# sourceMappingURL=maintenance.mjs.map
/// <reference types="./maintenance.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class Complete extends $CustomType {
  constructor(starting, ending) {
    super();
    this.starting = starting;
    this.ending = ending;
  }
}
export const Maintenance$Complete = (starting, ending) =>
  new Complete(starting, ending);
export const Maintenance$isComplete = (value) => value instanceof Complete;
export const Maintenance$Complete$starting = (value) => value.starting;
export const Maintenance$Complete$0 = (value) => value.starting;
export const Maintenance$Complete$ending = (value) => value.ending;
export const Maintenance$Complete$1 = (value) => value.ending;

export class Banner extends $CustomType {
  constructor(starting, ending, content) {
    super();
    this.starting = starting;
    this.ending = ending;
    this.content = content;
  }
}
export const Maintenance$Banner = (starting, ending, content) =>
  new Banner(starting, ending, content);
export const Maintenance$isBanner = (value) => value instanceof Banner;
export const Maintenance$Banner$starting = (value) => value.starting;
export const Maintenance$Banner$0 = (value) => value.starting;
export const Maintenance$Banner$ending = (value) => value.ending;
export const Maintenance$Banner$1 = (value) => value.ending;
export const Maintenance$Banner$content = (value) => value.content;
export const Maintenance$Banner$2 = (value) => value.content;

export const Maintenance$ending = (value) => value.ending;
export const Maintenance$starting = (value) => value.starting;

export function encode(maintenance) {
  if (maintenance instanceof Complete) {
    return $json.object(
      toList([
        ["kind", $json.string("total")],
        ["ending", $timestamp_.encode(maintenance.ending)],
        ["starting", $timestamp_.encode(maintenance.starting)],
      ]),
    );
  } else {
    return $json.object(
      toList([
        ["kind", $json.string("banner")],
        ["content", $json.string(maintenance.content)],
        ["ending", $timestamp_.encode(maintenance.ending)],
        ["starting", $timestamp_.encode(maintenance.starting)],
      ]),
    );
  }
}

export function decoder() {
  return $decode.field(
    "ending",
    $decrypt.timestamp(),
    (ending) => {
      return $decode.field(
        "starting",
        $decrypt.timestamp(),
        (starting) => {
          return $decode.field(
            "kind",
            $decode.string,
            (kind) => {
              if (kind === "total") {
                return $decode.success(new Complete(starting, ending));
              } else if (kind === "banner") {
                return $decode.field(
                  "content",
                  $decode.string,
                  (content) => {
                    return $decode.success(
                      new Banner(starting, ending, content),
                    );
                  },
                );
              } else {
                return $decode.failure(
                  new Complete(starting, ending),
                  "Maintenance",
                );
              }
            },
          );
        },
      );
    },
  );
}

export function assoc_decoder() {
  return $decode.list(
    $decode.field(
      "maintenance",
      decoder(),
      (maintenance) => {
        return $decode.field(
          "org_id",
          $decode.string,
          (org_id) => { return $decode.success([org_id, maintenance]); },
        );
      },
    ),
  );
}

export function encode_assoc(maintenances) {
  return $json.array(
    maintenances,
    (_use0) => {
      let org_id = _use0[0];
      let maintenance = _use0[1];
      return $json.object(
        toList([
          ["org_id", $json.string(org_id)],
          ["maintenance", encode(maintenance)],
        ]),
      );
    },
  );
}
